import {Inject, Injectable, OnDestroy} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {io} from 'socket.io-client';
import {IWebsocketService, IWsMessage} from '@core/models/websocket';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {filter, map, tap} from 'rxjs/operators';
import {decodeFunc} from '@core/tools/utils';
import {environment} from '@environments/environment.prod';

@Injectable({
    providedIn: 'root'
})
export class WebsocketService implements IWebsocketService {

    connected$ = new Subject();
    private forceStopped: boolean;
    private connectionCheck: any;
    private sid: string;
    private socket: any;
    private loginPromise: any;
    private lastEventId: any;
    private loginInterval = 1000 * 60;
    private connected: boolean;
    private message = new BehaviorSubject<any>(null);

    constructor(@Inject(DOCUMENT) private document) {


    }

    get getConnection(): boolean {
        return this.connected;
    }

    connect(userId: number): void {
        this.createSocket(environment.socket, userId);
    }

    startLogin() {
        if (this.loginPromise) {
            this.stopLogin();
        }

        this.loginPromise = setInterval(() => {
            this.tryLogin();
        }, this.loginInterval);
    }

    tryLogin() {
        const objToSend = {
            type: 'login',
            body: 'None',
            session_id: this.sid,
            machine_id: 'web',
            last_event_id: this.lastEventId
        };

        // console.log('Socket: try login session_id:' + this.sid, objToSend);
        const toSend = JSON.stringify(objToSend);
        this.socket.send(toSend);
    }

    stopLogin() {
        if (this.loginPromise) {
            clearInterval(this.loginPromise);
            this.loginPromise = null;
        }
    }

    changeConnectStatus(newStatus, need_refresh_cash = true, write_tokens = null, device = null): void {
        // console.log('changeConnectStatus:  status connection to:' + newStatus + ' from:' + this.connected);
        if (this.connected !== newStatus) {
            this.connected = newStatus;
            if (newStatus) {
                this.connected$.next({need_refresh_cash, write_tokens, device});
            } else {
                setTimeout(() => {
                    if (!this.connected) {
                        if (this.connectionCheck) {
                            clearInterval(this.connectionCheck);
                        }
                        this.disconnect();
                    }

                }, 3000);


            }
        }
    }

    createSocket(path: string, userId: number): void {

        if (this.forceStopped) {
            return;
        }

        if (!this.socket) {
            // console.log('Socket: try create');
            const options = {
                withCredentials: false,
                extraHeaders: {
                    'x-id-header': userId
                },
                reconnectionAttempts: 100,
                reconnectionDelay: 3000,
                reconnectionDelayMax: 5000,
                randomizationFactor: 0.5,
                timeout: 5000,
            };
            // @ts-ignore
            this.socket = io(path, options);
            this.socket.on('connect', () => {
                this.connected = true;
                // console.log('Socket: connected');
                // this.startLogin();
            });
            this.socket.on('connect_error', () => {
                // console.error('Socket: connection error', arguments);
                this.stopLogin();
                this.disconnect();
            });
            this.socket.on('reconnect_attempt', (num) => {
                // console.error('Socket: reconnect_attempt ' + num);
                this.stopLogin();
            });
            this.socket.on('message', (msg) => {
                try {
                    const event = JSON.parse(msg);
                    if (event && event.event && event.data) {
                        console.log(event);
                        this.message.next(event.data);
                    }
                } catch (err) {

                }

            });
            this.socket.on('disconnect', () => {
                // console.log('Socket: disconnected', arguments);
                this.stopLogin();
                this.disconnect();
            });
            this.socket.on('error', () => {
                // console.log('Socket: any error', arguments);
            });
            this.socket.on('reconnect_error', () => {
                // console.log('Socket: reconnect_error', arguments);
            });
            this.socket.on('reconnect', () => {
                // console.log('Socket: reconnect', arguments);
            });

        } else {
            if (!this.connected && !this.socket.connecting) {
                this.socket.connect();
            }
        }
    }

    disconnect(): void {
        // console.log('On disconnect sockets');
        if (this.socket) {
            if (this.connected) {
                this.socket.disconnect();
            }
            this.socket.removeAllListeners();
            this.socket = null;
            this.lastEventId = null;
        }
    }

    public on<T>(): Observable<T> {
        return this.message
            .pipe(filter(f => !!f));
    }

    public send(event: string, data: any = {}): void {
        if (event && this.connected) {
            this.socket.send(JSON.stringify({event, data}));
        } else {
            console.error('Send error!');
        }
    }

}
